import { baseErrorHandler } from '@queries/baseErrorHandler';
import { $api } from '@service/RequestService';
import { useMutation, useQueryClient } from 'react-query';

import { crmConstants } from '..';

export function useGoogleSheetsConfig() {
  const qc = useQueryClient();

  const { data, ...arg } = useMutation(
    async (payload: any) => {
      const { data } = await $api.post('/v1/crm/drive/config', payload);

      return data?.data;
    },
    {
      onError: baseErrorHandler,
      onSuccess: async () => {
        await qc.invalidateQueries([crmConstants.queryKeys.GOOGLE_SHEETS_ACCOUNT]);
      }
    }
  );

  return { data, ...arg };
}
